import { PhoneCall } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, COMPANY } from "@/lib/site-content";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-zinc-950 text-zinc-300 py-12 sm:py-16"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div className="grid md:grid-cols-12 gap-10 mb-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 bg-[#FF4500] flex items-center justify-center text-white font-black font-display text-lg">
                S
              </span>
              <span className="font-display font-black text-xl tracking-tight text-white">
                {COMPANY}
              </span>
            </div>
            <p className="text-sm leading-relaxed max-w-md">
              Specpay Solutions is a third-party utility concierge connecting
              residential customers with electricity, gas and water providers
              across the United States.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="label-eyebrow text-zinc-500 mb-4">Services</p>
            <ul className="space-y-2 text-sm">
              <li><a href="#services" className="hover:text-white">Start service</a></li>
              <li><a href="#services" className="hover:text-white">Stop service</a></li>
              <li><a href="#services" className="hover:text-white">Move service</a></li>
              <li><a href="#services" className="hover:text-white">Pay bill</a></li>
              <li><a href="#services" className="hover:text-white">Manage account</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="label-eyebrow text-zinc-500 mb-4">Contact</p>
            <a
              href={PHONE_TEL}
              data-testid="footer-call-button"
              className="inline-flex items-center gap-2 font-display font-black text-2xl text-white hover:text-[#FF4500] transition-colors"
            >
              <PhoneCall className="w-5 h-5 text-[#FF4500]" strokeWidth={2.7} />
              {PHONE_DISPLAY}
            </a>
            <p className="mt-3 text-sm text-zinc-500">24/7 · All 50 states</p>
            <a
              href={PHONE_TEL}
              className="mt-5 inline-flex items-center justify-center gap-2 bg-[#FF4500] hover:bg-[#E63E00] text-white font-display font-bold px-6 py-3 transition-all active:scale-[0.97]"
            >
              Call now
            </a>
          </div>
        </div>

        <div className="border-t border-zinc-800 pt-6 flex flex-col sm:flex-row gap-3 sm:items-center justify-between text-xs text-zinc-500">
          <p>© {new Date().getFullYear()} {COMPANY}. All rights reserved.</p>
          <p>
            Specpay Solutions is not a utility provider. We facilitate service
            requests with regulated providers in your area.
          </p>
        </div>
      </div>
    </footer>
  );
}
